import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import $ from 'jquery';

const MP3_URL_OF_WORD = 'https://api.dictionaryapi.dev/api/v2/entries/en/';

class PlayWord extends React.Component {

  constructor(props) {
    console.log(props.src);
    super(props);
    this.state = { playing: false, };
    this.audio = new Audio();
  }

  play = () => {
    this.setState({playing: true});
    this.audio.src = this.props.src;
    this.audio.play();
  }

  pause = () => {
    this.setState({playing: false});
    this.audio.pause();
  } 

  render() {
    return (
      <span onClick={this.state.playing ? this.pause : this.play}>
        &nbsp;
        <Glyphicon bsSize="xsmall" title="播放" glyph="volume-up" />
      </span>
    )
  }

}

export default PlayWord;



// WEBPACK FOOTER //
// ./src/PlayWord.js